// Top bar (Tool Plan §3 rules 6–7, §4.14, D-56, D-67; I-1a Batch 4 + 5).
// Hide and Help now on every screen, from the first one, before and after
// unlock — kept apart, at the two ends of the bar, so one is never tapped for
// the other. Icon + visible label (rule 13). The product name is not a heading;
// each screen has its own. Back · Home join with the real screens (I-1b).

import { PRODUCT_NAME, safety } from '../screens/copy'

interface TopBarProps {
  readonly onHide: () => void
  readonly onHelpNow: () => void
}

export function TopBar({ onHide, onHelpNow }: TopBarProps): React.JSX.Element {
  return (
    <header className="topbar">
      <button type="button" className="topbar__button" onClick={onHide}>
        <svg className="topbar__icon" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
          <path d="M3 12s3.5-6 9-6c1.6 0 3 .4 4.2 1M21 12s-3.5 6-9 6c-1.6 0-3-.4-4.2-1" />
          <path d="M4 20L20 4" />
        </svg>
        <span>{safety.hide}</span>
      </button>
      <span className="topbar__name">{PRODUCT_NAME}</span>
      <button type="button" className="topbar__button" onClick={onHelpNow}>
        <svg className="topbar__icon" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
          <circle cx="12" cy="12" r="8" />
          <circle cx="12" cy="12" r="3.2" />
          <path d="M6.3 6.3l3.4 3.4M17.7 6.3l-3.4 3.4M6.3 17.7l3.4-3.4M17.7 17.7l-3.4-3.4" />
        </svg>
        <span>{safety.helpNow}</span>
      </button>
    </header>
  )
}
